import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: ' Ngành logistics đóng vai trò cốt lõi trong việc tối ưu hóa thời gian và nguồn lực, đồng thời nâng cao dịch vụ khách hàng. Tuy nhiên, để duy trì năng lực cạnh tranh trong ngành logistics hiện đại, việc tích cực áp dụng các công nghệ mới nhất là điều bắt buộc.',
  keywords:
    'Trung tâm logistics, global logistics, logistics toàn cầu, SCM, quản lý kho, trung tam logistics, global logistics, logistics toan cau, SCM, quan ly kho.',
  ogSite: 'Các xu hướng công nghệ mới nhất mà người trong ngành logistics cần biết',
  title: 'Các xu hướng công nghệ mới nhất mà người trong ngành logistics cần biết',
  ogUrl: 'https://orbro.io/vi/blog/logisticsTech',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4PVu4kuy9M18H7FmFyW0Q0eESSyhQnDGg14oHiyiErzgaj9C6c04JTCmvEdjNFy1RXc-dFULyWRt2kEo4Cc08fuynbaorsmbVA1WZzOjFxamTouK1BSdqmJMWpihlk4UT2DwWY82EunIjppF5ShLp_E_SC2kVFAxBNtgKGuiHxsQedwiLBHpCzoo9wHtnqwDT_VLhRXu6kCMciziqklxTVzgLUnGfJx4fwSZCUeP_97fRfmoRUa74mRFh7J3r_WHTjKEM6lA3ewY1aFfygHCHH9YILBsyiOObeQqrP-rwrQsFFN9tegAJUWXqMBIdU0iZrmP8BE5aKgWUlkcv4BGfmKVIsOLypMPvOlrwLGc69gq-Ry-75Kq70RLYMXTIGNBeFCX1OoWSQXyi8xtlMbio4P-R3SYRfST4i-NaC0uTHKYNFw4X2pi32DpBC6ABiJ36qYntNOyIjav_Gxsj1J1hX7f11VXEpXn99emstdDgDQWVe0GJFpuy3S1BLOUnHHYb5Yp_2rUPdF5zaDip7wpsdirHI_gwcVPrVnx5OVX7sN5sH0v5olOvB6lhlq_3tH8L4f_Ih_I--vbGOsYnN246AvMx8BGjB3rLXnW38UK3Kv0JxhnL3evbCmOTKHnYQnAPMDby0LP_J1vGGTSKJB4saPBtfth2jWZCp_D33p2wPA9m3rIJ1GioOjoX8aVnl2McRmhcN0ee-3khHAkTH9Sw5Mselb8HbNlXC-5exUaPJUbLnSf3wU6xV6KyRieN_TsqtfixN6mgR2fSkpi2AA_Pn73zqkACZWSox-925fxgQtg_hoEFlaR4ctPdpWcXQ9V9EN1bMwxcXtV8NT2WDiF7MdEVpabwIUTZHPoFOPvkghuiqSMTiwQzCFgFwMqRR08jXN8Hbo4keOhSlyUhbuIcC0_vdkNI_yh_kUYLpdIlBOwk-amXrN-hdOwqTPkyuRmSAaKUPWgVhktIsP_WOlCXBncp4asz71pEvRywDGh_h9ou449w69BkNSjl7l-ODWpERmlmSTxjEkb3GGqjvn7S-DjtWWD1w_Xac7yZmMcNlenRvfma_bkN_2S4XW7zKnTl7H4gcmDtlt2igFE2Rdcg18vvfDs6vZJIAhmUZ_wo_-ki7qRtKsV-NZXEhxNCPtPbyxuVAdzRL7HWzn8ZpF3eK-2k87_zuS9aU9ofyaMoWiEXplANKhTzbhPz0Do_-QxjH9qHlnJot70a7mOr2kGcV9pRM_frc9CgYJC11tSxs6Mwoi3BKJkqZ7PlpCzTwyI9Fb0sBI3v-TvJO47RzrytQVLmvZdtB_divnOJkV6CNET7k5gTn2ICf7eQb_8YapYc_2eH8DW1YPqCN09n8C5uGq8lkpYedIdlXTsFHrVqUEluhRuaLZSegaV1oMdbzvS90L5WrpSKP-YPBc4D_OTgGXjA7Jha06Ccb_vGhacNAfFznQ7SJXS-Pp2ufPn2ymczEn4LHRbDw-f7upsbuw9uLEMWNSvzZsulGa4DjUZLuP2oEHwtbNu_qq8M1bYNyUzAAD4z9_lTWLQrG6ErWZVmxc1R-Qq-_71PIB1v_zizOFA2EeBYuNCXK_B0J4Hw=w2052-h1199',
  ogType: 'website',
  date: '2023-09-13',
  tag1: '#Trungtamlogistics',
  tag2: '#Globallogistics',
  tag3: '#Logisticstoancau',
  tag4: '#SCM',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Ngành logistics đóng vai trò cốt lõi trong việc tối ưu hóa thời gian và nguồn lực, đồng thời nâng cao dịch vụ khách hàng. Tuy nhiên, để duy trì năng lực cạnh tranh trong ngành logistics hiện đại, việc tích cực áp dụng các công nghệ mới nhất là điều bắt buộc. Bởi vì, như mọi khi, những đổi mới luôn đi kèm với công nghệ mới. Một trong những công nghệ đang được chú ý trong những năm gần đây là công nghệ RTLS (Real-Time Location System). Công nghệ RTLS đang mang lại những thay đổi mang tính cách mạng cho nhiều nhóm ngành, đặc biệt là ngành logistics, và chúng ta sẽ xem xét công nghệ này có thể đổi mới và thúc đẩy ngành logistics phát triển như thế nào trong tương lai.',
      dot: '',
    },
    {
      head: 'Khái niệm về Công nghệ RTLS',
      subHead: '',
      desc: 'RTLS là viết tắt của Real-Time Location System, có nghĩa là Hệ thống Định vị Thời gian Thực. Đây là hệ thống kết hợp nhiều công nghệ đa dạng như truyền thông không dây, cảm biến (sensor), phân tích dữ liệu (data analysis), v.v., để theo dõi và quản lý vị trí của vật thể, thiết bị hoặc nhân lực theo thời gian thực. Công nghệ RTLS sử dụng nhiều công nghệ khác nhau như RFID (Radio-Frequency Identification), GPS (Global Positioning System), UWB (Ultra-Wideband), v.v., để thu thập thông tin vị trí và truyền thông tin này đến hệ thống trung tâm để giám sát theo thời gian thực.\n\nVậy thì, công nghệ này có thể được áp dụng như thế nào tại các cơ sở logistics và lợi ích mang lại là gì?',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng RTLS trong ngành Logistics',
      subHead: '1. Quản lý và duy trì hàng tồn kho ',
      desc: 'Công nghệ RTLS đã mang lại những thay đổi mang tính cách mạng cho việc quản lý hàng tồn kho trong ngành logistics. Thoát khỏi phương pháp quản lý thủ công truyền thống, giờ đây có thể nắm bắt vị trí và tình trạng của hàng hóa và thiết bị theo thời gian thực. Qua đó, có thể phòng ngừa các vấn đề như thiếu hàng hoặc tồn kho quá nhiều và cắt giảm chi phí logistics. Về cơ bản, việc quản lý hàng tồn kho này được hiển thị theo thời gian thực trên một giao diện (interface) trực quan. Đây là một hệ thống mà bất kỳ ai không có kiến thức chuyên môn cũng có thể dễ dàng hiểu và sử dụng.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Tự động hóa quy trình làm việc',
      desc: 'Sử dụng RTLS có thể tự động hóa quy trình làm việc trong logistics. Ví dụ, có thể theo dõi vị trí và chuyển động của các bộ phận trên dây chuyền lắp ráp ô tô, hoặc cho phép robot tự động lấy và sử dụng các bộ phận. Điều này giúp nâng cao hiệu quả công việc và giảm thiểu sai sót.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Quản lý vận tải và giao nhận',
      desc: 'Công nghệ RTLS cũng đóng vai trò quan trọng trong quy trình vận tải và giao nhận. Việc xác định vị trí hàng hóa theo thời gian thực giúp tối ưu hóa lộ trình vận chuyển và quản lý lịch trình giao hàng dễ dàng hơn. Hơn nữa, có thể giám sát tình trạng hàng hóa để phòng ngừa hư hỏng và cung cấp dịch vụ giao hàng nhanh chóng, chính xác hơn cho khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Quản lý an toàn',
      desc: 'Không chỉ tài sản mới có thể được theo dõi theo thời gian thực. Có thể theo dõi người lao động và thiết bị nặng đang làm việc tại hiện trường, và gửi cảnh báo theo thời gian thực để có biện pháp xử lý khi họ tiếp cận khu vực nguy hiểm hoặc có nguy cơ va chạm.',
      dot: '',
    },
    {
      head: 'Ưu điểm và Giá trị của RTLS',
      subHead: '1. Giám sát thời gian thực',
      desc: 'Thông qua RTLS, có thể nắm bắt vị trí và tình trạng của hàng hóa, thiết bị hoặc người lao động theo thời gian thực. Nhờ đó, có thể ứng phó nhanh chóng khi có vấn đề phát sinh và tối ưu hóa quy trình.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Thu thập dữ liệu chính xác',
      desc: 'RTLS thu thập dữ liệu vị trí chính xác, do đó giảm thiểu sai sót trong các công việc như quản lý hàng tồn kho, vận chuyển, giao nhận và nâng cao hiệu quả logistics.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Cắt giảm chi phí',
      desc: 'Sử dụng RTLS giúp quản lý hiệu quả nhân lực và tài nguyên, đồng thời giảm chi phí phát sinh trong quá trình quản lý hàng tồn kho và vận chuyển.',
      dot: '',
    },
    {
      head: 'Tương lai của RTLS',
      subHead: '',
      desc: 'Công nghệ RTLS được dự đoán sẽ tiếp tục phát triển và mang lại sự đổi mới cho ngành logistics. Sự kết hợp với Machine Learning (Học máy) và Artificial Intelligence (Trí tuệ nhân tạo - AI) được kỳ vọng sẽ cung cấp các chức năng dự đoán và tối ưu hóa tinh vi hơn, đồng thời cũng sẽ có những cải tiến về mặt bảo mật và bảo vệ thông tin cá nhân. Những người làm trong ngành logistics cần theo dõi sát sao các xu hướng công nghệ này và tích cực áp dụng để duy trì năng lực cạnh tranh và chuẩn bị cho tương lai.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Đối với những người làm trong ngành logistics, công nghệ RTLS mang đến những khả năng đổi mới, giúp tối ưu hóa quy trình logistics và cắt giảm chi phí. Công nghệ này được dự đoán sẽ đóng vai trò quan trọng, dẫn dắt tương lai của ngành logistics, do đó việc tích cực đón nhận và áp dụng nó là cần thiết. Hãy cùng ứng dụng hiệu quả công nghệ RTLS để đóng góp vào sự tăng trưởng và phát triển của ngành logistics.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
